import {
    Button,
    createButton,
} from '@vfde-brix/ws10/button';
import {
    BASKET_WITH_GIGAKOMBI_BUTTON_ID,
    BASKET_WITHOUT_GIGAKOMBI_BUTTON_ID,
} from 'Container/App/constants';
import { Overlay } from '@vfde-brix/ws10/overlay';
import { goToBasket } from 'Container/App/slice';
import { useDispatch } from '../store';

/**
 * Button component
 */
export const mountOverlayButtons = (
    overlay: Overlay,
): Button[] => {
    const dispatch = useDispatch();

    const gkButton = overlay.getOverlayContentContainer().querySelector(`#${BASKET_WITH_GIGAKOMBI_BUTTON_ID}`);
    const noGkButton = overlay.getOverlayContentContainer().querySelector(`#${BASKET_WITHOUT_GIGAKOMBI_BUTTON_ID}`);

    const gkButtonComponent = gkButton && createButton(gkButton, {
        onClick: () => {
            dispatch(goToBasket(true));
            overlay.close();
        },
    });

    const noGkkButtonComponent = noGkButton && createButton(noGkButton, {
        onClick: () => {
            dispatch(goToBasket(false));
            overlay.close();
        },
    });

    return [gkButtonComponent, noGkkButtonComponent].filter(Boolean) as Button[];
};
